export default __webpack_public_path__ + "static/media/element_bg01_wpp.0ff7408d.svg";